import React from 'react';
import {
    Box,
    Switch,
    Typography,
} from "@mui/material";
import { ReceiptLongRounded } from "@mui/icons-material";
import { toPriceWithComma } from "../../../helper/utils";

const _ChargeSummaryBreakdown = ({
    selectedGateway,
    requestProFormaInvoice,
    setRequestProFormaInvoice,
    rawAmount,
    taxAmount,
    taxPrice,
    totalAmount,
}) => {
    return (
        <>
            {/* 4. Pro-Forma Invoice Switch */}
            {selectedGateway?.Gateway?.GatewayType !== "BANK_PORTAL" && (
                <Box
                    sx={{
                        p: 2,
                        px: 2.5,
                        borderRadius: 3,
                        bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.015)',
                        border: '1px solid',
                        borderColor: 'divider',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 1.5
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                        <ReceiptLongRounded sx={{ color: 'primary.main' }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
                                صدور و ثبت پیش‌فاکتور
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                جهت ارائه به امور مالی و پرداخت از طریق واریز سازمانی
                            </Typography>
                        </Box>
                    </Box>
                    <Switch
                        checked={requestProFormaInvoice}
                        onChange={(e) => setRequestProFormaInvoice(e.target.checked)}
                        color="primary"
                    />
                </Box>
            )}

            {/* 5. Summary Breakdown */}
            {rawAmount >= 500000 && (
                <Box
                    sx={{
                        p: 2.5,
                        borderRadius: 3.5,
                        bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(28, 139, 156, 0.08)' : 'rgba(28, 139, 156, 0.04)',
                        border: '1px solid',
                        borderColor: 'rgba(28, 139, 156, 0.2)'
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>مبلغ پایه افزایش شارژ:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800 }}>{toPriceWithComma(rawAmount)} تومان</Typography>
                    </Box>
                    {taxAmount > 0 && (
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>مالیات بر ارزش افزوده ({taxPrice}٪):</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 800 }}>{toPriceWithComma(taxAmount)} تومان</Typography>
                        </Box>
                    )}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 1.5, borderTop: '1px dashed', borderColor: 'rgba(28, 139, 156, 0.3)' }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 900, color: 'text.primary' }}>
                            مبلغ کل قابل پرداخت:
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: 900, color: 'primary.main' }}>
                            {toPriceWithComma(totalAmount)} تومان
                        </Typography>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default _ChargeSummaryBreakdown;
